interface Configuration {
  environment: 'local' | 'staging' | 'production';
  build: string;
  uri: {
    api: string;
    app: string;
    web: string;
    /** Dorsia booking origin (SPA) that hosts /embed/pay for the overlay iframe. */
    booking: string;
  };
  stripe: {
    key: string;
  };
  mapbox: {
    username: string;
    access_token: string;
    style_id: string;
  };
  recaptcha?: {
    site_key: string;
  };
}

// Build-time configuration from environment variables (Vercel)
const buildConfig = (): Configuration => ({
  environment: (import.meta.env.VITE_ENVIRONMENT ||
    import.meta.env.MODE) as Configuration['environment'],
  build: import.meta.env.VITE_BUILD || 'unknown',
  uri: {
    api: import.meta.env.VITE_API_URL || 'https://api.dorsia.com/api',
    app: import.meta.env.VITE_APP_URL || 'https://members.dorsia.com',
    web: import.meta.env.VITE_WEB_URL || 'https://dorsia.com',
    booking: import.meta.env.VITE_BOOKING_URL || 'https://book.dorsia.com',
  },
  stripe: {
    key: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
  },
  mapbox: {
    username: import.meta.env.VITE_MAPBOX_USERNAME || 'dorsia',
    access_token: import.meta.env.VITE_MAPBOX_TOKEN || '',
    style_id: import.meta.env.VITE_MAPBOX_STYLE_ID || 'clly0c6c8009401rc0em67h92',
  },
  recaptcha: import.meta.env.VITE_RECAPTCHA_SITE_KEY
    ? { site_key: import.meta.env.VITE_RECAPTCHA_SITE_KEY }
    : undefined,
});

export default class Config {
  static data: Configuration = buildConfig();

  // Keep setFromFile for backwards compatibility, but it's now a no-op
  public static setFromFile = async () => {
    // Config is now loaded at build time from env vars
    // This method is kept for backwards compatibility
  };
}
